export enum NETWORK_INTERFACES_TYPES {
  WAN = "WAN",
  VPN = "VPN",
}

export enum WIFI_BANDS {
  "WIFI_5G" = "5Ghz",
  "WIFI_2.4G" = "2.4Ghz",
}
